import { DatePipe } from '@angular/common';
import { Component, OnInit, Optional, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from 'app/dashboard/dashboard.service';

import { MatTableDataSource } from '@angular/material/table';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ServiceList } from '../Models/billing.Models';
import { ReciptFormModel, RefundFormModel } from '../Models/billdetail.model';
import { MatDialog } from '@angular/material/dialog';
import { RefundComponent } from '../refund/refund.component';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import * as moment from 'moment';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';

@Component({
  selector: 'app-recipt',
  templateUrl: './recipt.component.html',
  styleUrls: ['./recipt.component.scss']
})
export class ReciptComponent implements OnInit {

  todaysdate: any
  displayedColumns: string[] = ['serviceName', 'rate', 'qty', 'maxDiscountLimit', 'discount', 'serviceCharge', 'netAmount', 'serviceId'];
  dataSource = new MatTableDataSource<ServiceList>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  // BillingData:BillingFormModel={};
  ReciptData: ReciptFormModel = {};
  RefundData: RefundFormModel = {};
  public masterconfigurationDiscount: any;
  //  patientid:number
  walkin = true;
  showspinner = false;
  withappointment = false;
  quantity = 1;
  totalpay: any;
  servicecharge: any;
  lessDiscount: any;
  netbillamount: any = 0;
  currentpayable: any;
  checktpa = 0;
  startdate: any;
  cuurentTime: any;
  BillDetailArray: any = [];
  checkService: any;
  partyAmount: any;
  copartyAmount: any;
  copartyId: any;
  public PartialAmount: any = 0;
  DipositeType: any = [];
  BnakType: any = [];
  PaymentType: any = [];
  ReciptArray: any = [];
  getreciptobj: any[];
  PatientId: number;
  BillID: number; t
  PartialBalancedAmmount: number = 0;
  dyanmiccheck: boolean = false;
  public AdjustedBillArray: any = [];
  adjuctbillAmount: any = [];
  public checkAdvancereciept: boolean = false;
  BillReciptAmount: number;

  public issubmit = false;
  MinimeDate: any;
  reporturl: any;
  PageHeader: any;
  isprint: boolean;
  QrCode: any;
  totalpadamountAgainstBill: number;
  checkpartialAdjust: boolean;
  rowClicked: any=-1;
  patientPartyTpaconf: any;
  Unadjustobj: any = {}
  selectreceiptid: number = null;
  deposittype: any = null;
  checkreceiptselect: boolean = false;
  bankdetailelvel1: any = "Card/Cheque No.";
  bankdetailelvel2: any = "Card/Cheque Date";
  DoctorName: string;
  saveUsername: boolean;
  show: boolean = true;
  RdataPrint: any;
  constructor(public authService: AuthService, public dialog: MatDialog, public branchMatserService: BranchMatserService, public ipdService: IPDService,
    public dashboardService: DashboardService,
    public opdvisitService: OpdVisitService, private datePipe: DatePipe,
    public router: Router, public translate: TranslateService,
    public dialogRef: MatDialogRef<ReciptComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public billingservice: BillingserviceService) {
    //   setInterval(() => {this.cuurentTime =  new Date().toTimeString().split(" ")[0]}, 1);
    // console.log(this.billingservice.servicelist);


  }

  ngOnInit() {
    this.partyArray =[];
    this.authService.getServertime();
    this.refereshRecieptData();
    this.getdipaymenttype();
    this.getdiposittype();
    this.getbanktype();
    this.ReciptData.ChequeDate = null;
    var data = this.data;
   
    this.setreciptformdata(data);
    this.MinimeDate = moment(new Date(this.authService.getServerDate)).format('YYYY-MM-DD');
    this.isprint = false;
    this.getproductmasterconfig();
    this.billingservice.AdjustedBillingAmount = 0;
    this.checkpartialAdjust = false;
    this.opdvisitService.patiendFullNameForReciept = '';
    //  this.PageHeader.propertyValue = 'Y';
    this.Unadjustobj = {};
    this.getBranchDetail(this.authService.Loggeduser.branchid);
  }

  checknetAmount: number = 0;
  changeTableRowColor(rid: any, recet: any, idx: any) {


    if (this.rowClicked === idx) {
      this.selectreceiptid = null;
      this.checkreceiptselect = false;
      this.rowClicked = -1;
      this.AdjustedBillArray = [];
      this.setreciptformdata(this.data);
      this.checknetAmount = 0;
    }
    else {
      this.checknetAmount = recet.netAmt;
      this.selectreceiptid = rid;
      this.checkreceiptselect = true;
      this.rowClicked = idx;
      this.getadjustedbills(rid, recet, idx);
      // this.ngOnInit();
      if (this.AdjustedBillArray.length > 0) {
        this.AdjustedBillArray = [];
        this.billingservice.getAdustedDetails(rid, this.BillID).subscribe(item => {
          this.AdjustedBillArray = item;

        });
      }

    }

  }

  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.billingservice.getproductionConfrigration(BranchId).subscribe(data => {
      // console.log('master confrigartion',data);
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element?.propertyName === "DiscountonBill") {
          this.masterconfigurationDiscount = element;
        }

        if (element?.propertyName === "PageHeadWebReport") {
          this.PageHeader = element;
        }
        if (element?.propertyName === "Patientsticker_barcode") {
          this.QrCode = element;
        }
        if (element?.propertyName === "PATIENT_TPA_PARTY_YN") {

          this.patientPartyTpaconf = element.propertyValue;


        } if (element.propertyName === "WebURL") {
          this.reporturl = element.propertyValue;
        }
        // else{
        //   this.QrCode.propertyValue = 'N';
        // }


        // public PageHeader:any ={};
        // public :any={};
      }
    })
  }

  refereshRecieptData() {
    this.checkAdvancereciept = false
    this.billingservice.savebilldetail.rateTypeId = 0;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.activevisit = 0;
    this.ReciptData = {};
    this.PartialAmount = 0;
    this.DipositeType = [];
    this.BnakType = [];
    this.PaymentType = [];
    this.ReciptArray = [];
    this.getreciptobj = [];
    this.PatientId = null;
    this.BillID = null;
    this.billingservice.billserviceConfig = null;
    this.PartialBalancedAmmount = 0;
    this.dyanmiccheck = false;
    this.AdjustedBillArray = [];
    this.adjuctbillAmount = [];
    this.billingservice.lastbillid = null;
    this.BillReciptAmount = 0;
    this.opdvisitService.PatientisExpire = null;
  }
  checkpartialamount: number = 0;
  get_recipt(p: number, b: number, c: number) {

    this.adjuctbillAmount = [];
    this.billingservice.getrecipt(p, b, c).subscribe(data => {
      if (data.length > 0) {
        this.isprint = true;
        this.ReciptArray = data;
        console.log(this.ReciptArray)
      }

      if (this.ReciptArray.length > 0) {
        var partialamount = 0;
        for (let index = 0; index < this.ReciptArray.length; index++) {
          this.billingservice.getAdustedDetails(this.ReciptArray[index].pK_ReceiptId, 0).subscribe(data => {

            if (data.statusCode) {
              this.ReciptArray[index].netAmt = (this.ReciptArray[index].netAmt + this.ReciptArray[index].amountTDS + this.ReciptArray[index].amountDiscount + this.ReciptArray[index].amountDisAllow + this.ReciptArray[index].amountST) - (this.ReciptArray[index].refunded);
            } else {

              if (data.length > 0) {
                partialamount = 0;
                data.forEach(item => {
                  if (this.ReciptArray[index].pK_ReceiptId === item.fK_ReceiptId) {
                    partialamount = partialamount + item.adjustedAmount;
                  }
                })
                this.ReciptArray[index].netAmt = (this.ReciptArray[index].netAmt + this.ReciptArray[index].amountTDS + this.ReciptArray[index].amountDiscount + this.ReciptArray[index].amountDisAllow + this.ReciptArray[index].amountST) - (this.ReciptArray[index].refunded + partialamount);
              }

            }

          })
        }
      }
      this.billingservice.getAdustedDetails(0, this.BillID).subscribe(data => {
        if (data.statusCode) {

        } else {

          this.adjuctbillAmount = data;
          this.changeAmount(this.ReciptData.FK_PartyId, 1);
        }
        this.ReciptData.AmountINR = this.ReciptArray[0]?.netAmt;
      })
      // this.billingservice.getAdustedDetails(0, this.BillID).subscribe(data => {
      //   if (data.statusCode) {
      //     if (this.ReciptArray.length > 0) {
      //       for (let index = 0; index < this.ReciptArray.length; index++) {
      //         var lastadjustamount =0;
      //         this.billingservice.getAdustedDetails(this.ReciptArray[index].pK_ReceiptId,0).subscribe(data => {

      //           if (data.statusCode) {

      //           }else{
      //             if(data.length>0){
      //               data.forEach(item=>{
      //                 if (this.ReciptArray[index].pK_ReceiptId === item.fK_ReceiptId) {
      //                   lastadjustamount =lastadjustamount + item.adjustedAmount;
      //                 }

      //               })

      //             }

      //           }
      //           this.ReciptArray[index].netAmt = this.ReciptArray[index].netAmt - (this.ReciptArray[index].refunded + lastadjustamount);
      //         })

      //       }
      //     }

      //   }
      //   else {
      //     this.adjuctbillAmount = data;
      //     this.changeAmount(this.ReciptData.FK_PartyId,1);
      //     console.log('adjusted', data);

      //     for (let index = 0; index < this.ReciptArray.length; index++) {
      //       var partialamount = 0;
      //       if (this.adjuctbillAmount.length > 0) {

      //         for (let i = 0; i < this.adjuctbillAmount.length; i++) {
      //           if (this.ReciptArray[index].pK_ReceiptId === this.adjuctbillAmount[i].fK_ReceiptId) {
      //             partialamount = partialamount + this.adjuctbillAmount[i].adjustedAmount;


      //           }
      //         }
      //         this.checkpartialamount = partialamount;
      //       };
      //       this.ReciptArray[index].netAmt = this.ReciptArray[index].netAmt - (this.ReciptArray[index].refunded + partialamount);

      //     }
      //     console.log(this.checkpartialamount);
      //   }

      // })


    })
  }

  updateadjustedAmount(e: number, obj: any) {

    const filterreceipt = this.ReciptArray.filter(item => item.pK_ReceiptId == this.selectreceiptid);
    if (filterreceipt[0]?.depositType == "Advance Deposit") {
      if ((filterreceipt[0]?.amount - filterreceipt[0]?.refunded) >= e) {
        this.checkpartialAdjust = false;
        document.getElementById("PartialAmountModel").style.display = "none";
        obj.adjustedAmount = e;
        if (this.data.PartyPay >= e) {
          this.billingservice.addPartialAmount(obj).subscribe(data =>
            this.success_partialAmount(data), err => this.failed_partialAmount(err)
          )
        }
        else {
          this.dashboardService.openSnackBar("You Can't adjust more than Party Amount ", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("You Can't adjust more than NetAmount ", "OK");
      }

    }
    else {
      if ((filterreceipt[0]?.amount - filterreceipt[0]?.refunded) >= e) {

        this.checkpartialAdjust = false;
        document.getElementById("PartialAmountModel").style.display = "none";
        obj.adjustedAmount = e;
        console.log('amount', e, 'object', obj);
        if (this.data.PartyPay >= e) {
          this.billingservice.addPartialAmount(obj).subscribe(data =>
            this.success_partialAmount(data), err => this.failed_partialAmount(err)
          )
        }
        else {
          this.dashboardService.openSnackBar("You Can't adjust more than Party Amount ", "OK");
        }

      } else {
        this.dashboardService.openSnackBar("You Can't adjust more than NetAmount ", "OK");
      }
    }




  }
  // get doctor list 
  getdoctorlist() {
    this.dashboardService.getall_doctors().
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find(fy => fy.pkFinYearId == finyearid).displayFinYear;
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      this.DoctorName = this.opdvisitService.doctors.filter(element => element.userId == this.data.recipobj.FK_DoctorId)[0].userName;
    }
    else {
      this.opdvisitService.doctors = data;
      this.DoctorName = this.opdvisitService.doctors.filter(element => element.userId == this.data.recipobj.FK_DoctorId)[0].userName;

    }

  }
  failed_doctors(err) {

  }
  //config billing module

  closedialog() {
    this.dialog.closeAll();
  }

  getConfiglist() {
    this.billingservice.billserviceConfig = {};
    let BranchId = this.authService.Loggeduser.branchid;
    //  let BranchId=1;
    this.billingservice.get_Bill_Congigrationlist(BranchId).
      subscribe(data => this.success_config(data), err => this.failed_config(err));
  }
  success_config(data) {
    // 
    this.billingservice.billserviceConfig = data[0];
    this.getRateList(this.billingservice.billserviceConfig.fK_PartyId);
    if (this.ReciptData.FK_DoctorId == 0) {
      this.ReciptData.FK_DoctorId = this.billingservice.billserviceConfig.fK_DoctorId;
    }
    // this.ReciptData.FK_PartyId =this.billingservice.billserviceConfig.fK_PartyId;

  }

  failed_config(err) {
    this.billingservice.billserviceConfig.fK_BillSerieseId = 0;
    this.billingservice.billserviceConfig.fK_BillTypeId = 0;
    this.billingservice.billserviceConfig.fK_CategoryId = 0;
    this.billingservice.billserviceConfig.fK_DoctorId = 0;
    this.billingservice.billserviceConfig.fK_ReferredById = 0;
    //  this.billingservice.billserviceConfig.fK_PartyId=0;
    this.billingservice.billserviceConfig.fK_RatelistId = 0;

  }
  // get Bill service 
  getBillservice() {
    this.billingservice.get_BillService().subscribe(data => this.success_bill(data), err => this.failed_billservice(err));
  }
  success_bill(data) {
    this.billingservice.billService = data;
  }
  failed_billservice(err) {

  }
  //get party tpa
  partyArray:any=[];
  getPartTpa(selfid:any,partyid:any) {
    this.billingservice.get_partytpa().subscribe(data => this.success_partytpa(data,selfid,partyid), err => this.failed_partytpa(err));
  }
  success_partytpa(data,selfid,partyid) {
     this.billingservice.partytpa = data;
     this.copartyId = this.billingservice.partytpa[1].pkPartyId;
    const allowedIds = [selfid, partyid]; // Add more if needed
    this.partyArray = data.filter(item => allowedIds.includes(item.pkPartyId));
   
   
    // console.log('partyNme',this.billingservice.partytpa);
  }
  failed_partytpa(err) {

  }


  openModalDialog(data) {
    document.getElementById("recipModel").style.display = "block";
    // this.setreciptdata(data);
  }

  closeModalDialog() {
    // this.display='';
    document.getElementById("recipModel").style.display = "none";
    this.ReciptData = {};
    // this.BillingData = {};

  }
  // get rate typelist

  GetRateType() {
    this.billingservice.get_rate_typelist().pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {

      this.billingservice.ratetype = data;
      // console.log('billingservice.ratetype',data)
    })
  }

  GetBillType() {
    this.billingservice.get_typelist().pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {
      this.billingservice.billtype = data;
    })
  }
  //get rate list 
  getRateList(event) {
    if (event != 0) {
      let BranchId = this.authService.Loggeduser.branchid;
      let PartyId = event;
      this.billingservice.get_rate_list(BranchId, PartyId).pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {

        this.billingservice.ratelist = data[0];
        if (data.length > 0) {
          this.checktpa = 1;
        }
        // this.billingservice.ratelist[0].rateListId
      })
    } else {
      this.billingservice.ratelist.rateList = '';
      this.checktpa = 0;
    }
  }
  ngOnDestroy() {

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.partyArray =null;
  }

  // setbillingformdata(){
  //   this.ngOnInit();
  //   // this.setbiilingdata();
  //   }



  opensearchD(): void {
    // this.opdvisitService.get_top_200_patients().subscribe(
    //   data => this.success_top_200_patients(data),
    // );
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%"
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.defaultautoRef.nativeElement.focus();
      // console.log("The dialog was closed");
      // this.animal = result;
    });
  }

  // success_top_200_patients(data) {
  //   this.opdvisitService.patients = data;
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     // this.defaultautoRef.nativeElement.focus();
  //     // console.log("The dialog was closed");
  //     // this.animal = result;
  //   });
  // }




  setreciptformdata(a: any) {
 
    if(a.Billdetail.length >0){
       const selfid =a.Billdetail[0]?.fK_PartyId?a.Billdetail[0]?.fK_PartyId:false;
       const partyid =a.Billdetail[1]?.fK_PartyId?a.Billdetail[1]?.fK_PartyId:false;
       if(partyid >0){
        this.ReciptData.CurrencyAmount =a.Billdetail[1].amount;
        this.ReciptData.FK_PartyId = a.Billdetail[1].fK_PartyId;

       }else{
        this.ReciptData.CurrencyAmount =a.Billdetail[0].amount;
         this.ReciptData.FK_PartyId = a.Billdetail[0].fK_PartyId;
       }
      this.getPartTpa(selfid,partyid);
    }
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.opdvisitService.getpersonmaster('BILLING',0);
    this.getdoctorlist();
    this.getBillservice();
  //  this.getPartTpa();
    this.GetRateType();
    this.GetBillType();
    this.getConfiglist();
    this.getdiposittype();
    this.getdipaymenttype();
    this.getdipaymenttype();
    this.getdiposittype();
    this.getbanktype();
    this.AdjustedBillArray = [];
    var data = a.recipobj;
    // console.log(a)
    this.deposittype=null;
    this.opdvisitService.patientdetails.ageYear=a.PYear;
    this.opdvisitService.patientdetails.ageMonth =a.PMonth;
    this.opdvisitService.patientdetails.ageDays =a.PDays;
    this.PatientId = a.pid;
    this.BillID = a.billId;

    this.billingservice.lastbillid = a.billId;

    this.BillReciptAmount = data.CurrencyAmount;
    this.ReciptData.PaymentTime = this.cuurentTime;
    this.opdvisitService.patientdetails.pkRegId = this.PatientId;
    this.get_recipt(this.PatientId, this.BillID, 0);

    // if (a.checkAmount === true) {
    //   this.ReciptData.CurrencyAmount = 0
    // } else {

    // }
    // if (a.Copay > 0) {
    //   this.ReciptData.CurrencyAmount = a.PartyPay;
    // } else {
    //   this.ReciptData.CurrencyAmount = a.balanceAmount;
    // }
    this.ReciptData.PK_ReceiptId = data.PK_ReceiptId,
      this.ReciptData.ReceiptNo = data.ReceiptNo,
      this.ReciptData.FK_RegId = data.FK_RegId,
      this.ReciptData.FK_CreatedById = data.FK_CreatedById,
      this.ReciptData.FK_CancelledById = data.FK_CancelledById,
      this.ReciptData.PrintCount = data.PrintCount,
      this.ReciptData.IsActive = data.IsActive,
      this.ReciptData.FK_BillingCompanyId = data.FK_BillingCompanyId,
      this.ReciptData.FK_FinyearId = data.FK_FinyearId,
      this.ReciptData.FK_BranchId = data.FK_BranchId,
      this.ReciptData.PaymentDate = data.PaymentDate,
      this.ReciptData.FK_DoctorId = data.FK_DoctorId,

      this.ReciptData.FK_DepositHeadId = data.FK_DepositHeadId,
      this.ReciptData.FK_CurrencyId = data.FK_CurrencyId,
      this.ReciptData.FK_DepositTypeId = data.FK_DepositTypeId,
      this.ReciptData.ConvertRetio = data.ConvertRetio,
      
      this.ReciptData.AmountINR = data.AmountINR,
      this.ReciptData.AmountTDS = data.AmountTDS,
      this.ReciptData.AmountDiscount = data.AmountDiscount,
      this.ReciptData.AmountDisAllow = data.AmountDisAllow,
      this.ReciptData.AmountST = data.AmountST,
      this.ReciptData.FK_PayTypeId = data.FK_PayTypeId,
      this.ReciptData.ChequeNo = null;
    if (this.ReciptData.ChequeDate != null) {
      this.ReciptData.ChequeDate = moment(this.ReciptData.ChequeDate).format('YYYY-MM-DD')
    }
    this.ReciptData.FK_ChqBankId = data.FK_ChqBankId,
      this.ReciptData.RefBankBranch = data.RefBankBranch,
      this.ReciptData.FK_ClrBankId = data.FK_ClrBankId,
      this.ReciptData.IsCoPayment = data.IsCoPayment,
      this.ReciptData.IsAdjusted = data.IsAdjusted,
      this.ReciptData.FK_AdjustedBillId = data.FK_AdjustedBillId,
      this.ReciptData.UserRemarks = data.UserRemarks,
      this.ReciptData.Iscancelled = data.Iscancelled,
      this.ReciptData.RecptGenerateBSWise = data.RecptGenerateBSWise;
    if (data.CurrencyAmount > 0) {
      this.changeAmount(this.ReciptData.FK_PartyId);
    }




  }

  setreciptdata(data: any) {

    this.ReciptData = {};
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    //  console.log(data, )
    if (this.BillID > 0) {
      this.ReciptData.FK_AdjustedBillId = this.BillID;
    }
    else {
      this.ReciptData.FK_AdjustedBillId = data.fK_AdjustedBillId;
    }
     const allowedIds = [data.fK_PartyId]; // Add more if needed
     this.partyArray = this.billingservice.partytpa.filter(item => allowedIds.includes(item.pkPartyId));
    this.ReciptData.receiptNoFull = data.receiptNoFull,
      this.ReciptData.PK_ReceiptId = data.pK_ReceiptId,

      this.ReciptData.ReceiptNo = data.receiptNo,
      this.ReciptData.FK_RegId = data.fK_RegId,
      this.ReciptData.FK_DoctorId = data.fK_DoctorId,
      this.DoctorName = this.opdvisitService.doctors.filter(element => element.userId == data.fK_DoctorId)[0]?.userName,
      this.ReciptData.FK_CreatedById = this.authService.Loggeduser.userid,
      this.ReciptData.FK_CancelledById = data.fk_CancelledById,
      this.ReciptData.PrintCount = data.printCount,
      this.ReciptData.FK_PartyId = data.fK_PartyId,
      this.ReciptData.IsActive = data.isActive,
      this.ReciptData.FK_BillingCompanyId = data.fK_BillingCompanyId,
      this.ReciptData.FK_FinyearId = data.fK_FinyearId,
      this.ReciptData.FK_BranchId = data.fK_BranchId,
      this.ReciptData.PaymentDate = data.payDate,
      this.ReciptData.PaymentTime = data.paymentTime,
      this.ReciptData.FK_CancelledById = data.fK_CancelledById,
      this.ReciptData.FK_DepositHeadId = parseInt(data.fK_DepositHeadId),
      this.ReciptData.FK_CurrencyId = data.fK_CurrencyId,
      this.ReciptData.CurrencyAmount = data.currencyAmount,
      this.ReciptData.ConvertRetio = data.convertRetio,
      this.ReciptData.AmountINR = data.amount,
      this.ReciptData.AmountTDS = data.amountTDS,
      this.ReciptData.AmountDiscount = data.amountDiscount,
      this.ReciptData.AmountDisAllow = data.amountDisAllow,
      this.ReciptData.AmountST = data.amountST,
      this.ReciptData.FK_PayTypeId = data.fK_PayTypeId,
      this.ReciptData.ChequeNo = data.chequeNo,
      this.ReciptData.ChequeDate = moment(this.ReciptData.ChequeDate).format('YYYY-MM-DD')
    this.ReciptData.FK_ChqBankId = data.fK_ChqBankId,
      this.ReciptData.RefBankBranch = data.refBankBranch,
      this.ReciptData.FK_ClrBankId = data.fK_ClrBankId,
      this.ReciptData.FK_DepositTypeId = parseInt(data.fK_DepositTypeId),
      this.ReciptData.IsCoPayment = data.isCoPayment,
      this.ReciptData.IsAdjusted = data.isAdjusted;
      
    // if(data.isAdjusted ==0){
    //   this.ReciptData.IsAdjusted= this.BillID;
    // }
    // this.ReciptData.FK_ChqBankId =data.FK_ChqBankId


    this.ReciptData.UserRemarks = data.userRemarks,
      this.ReciptData.Iscancelled = data.iscancelled
    this.ReciptData.RecptGenerateBSWise = ""

    // console.log('set recipt obj',this.ReciptData)

  }

  // }


  getdiposittype() {
    this.billingservice.getdepositeType().subscribe(data => {
      // console.log('billpaytype',data);
      this.DipositeType = data;
    })
  }

  getdipaymenttype() {
    this.billingservice.getpaymentType().subscribe(data => {
      // console.log(data);
      this.PaymentType = data;
    })
  }

  getbanktype() {
    this.billingservice.getbankType().subscribe(data => {
      // console.log(data);
      this.BnakType = data;
    })
  }

  chnagePaymentMode(e) {
  
    var value = e;
    if (value== 1 || value == 2 || value == 3) {
      this.dyanmiccheck = value== 1?false:true;
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.ReciptData.ChequeNo = null;
      this.ReciptData.ChequeDate = this.authService.getServerDate;
      this.ReciptData.FK_ChqBankId = null;
      this.ReciptData.RefBankBranch = null;
      this.ReciptData.FK_ClrBankId = null;
      this.show = true;
      if(value ==1){
        this.ChequeNoValidation =false;
        this.ChqBankIdValidation=false;
      }
    } else {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Transaction No.";
      this.bankdetailelvel2 = "Transaction Date";
      this.ReciptData.ChequeNo = null;
      this.ReciptData.ChequeDate = this.authService.getServerDate;
      this.ReciptData.FK_ChqBankId = null;
      this.ReciptData.RefBankBranch = null;
      this.ReciptData.FK_ClrBankId = null;
      if (value == 7) {
        this.show = false;
      } else {
        this.show = true;
      }
     
    }
    
  }
  newdata: any;
  checkamountparty: any = 0;
  changeAmount(event: any, value?: any) {

    this.ReciptData.FK_PartyId = event;
    if (this.data.Billdetail.length > 0) {
      var receiptData = this.adjuctbillAmount.filter(item => item.fK_PartyId == event);
      if (receiptData.length > 0) {
        var caclucateamount = 0;
        receiptData.forEach(data => {
          caclucateamount = caclucateamount + data.adjustedAmount + (data.amountTDS + data.amountDiscount + data.amountDisAllow + data.amountST);
        });
        this.checkamountparty = caclucateamount;

      } else {
        this.checkamountparty = 0;
      }
      this.newdata = this.data.Billdetail.filter(item => (item.fK_PartyId == event || item.FK_PartyId == event));

      if (this.newdata.length > 0 && value == 1) {
        const checkamount = this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount;
        this.ReciptData.CurrencyAmount = checkamount - this.checkamountparty;
      } else if (value == 1) {
        this.ReciptData.CurrencyAmount = 0;
      }

    }
  }
  public onSaveUsernameChanged(value: boolean) {
    this.saveUsername = value;
    console.log(this.saveUsername);
    this.ReciptData.IsCoPayment = value
  }
  checkamount: any = 0;
  balanceAmount: any = 0;
  ChequeNoValidation:boolean = false;
  ChqBankIdValidation:boolean = false;
  AmountValidation:boolean = false;
  PartyValidation:boolean = false;
  submitAdvanceRecipt() {

    this.showspinner = true;
    this.checkamount == 0;
    if ((this.ReciptData.PK_ReceiptId != null || this.ReciptData.PK_ReceiptId != 0) && this.deposittype == "Advance Deposit") {
      this.dashboardService.openSnackBar("You Can't Update Advanced Receipt", "OK");
      this.showspinner = false;
      return;
    }
    if (this.ReciptData.PK_ReceiptId > 0) {
      this.dashboardService.openSnackBar("Please Un-Adjust The Receipt First.", "OK");
      this.showspinner = false;
      return;
    }

    if (this.ReciptData.AmountDisAllow == null) {
      this.ReciptData.AmountDisAllow = 0;
    }

    if (this.ReciptData.AmountDiscount == null) {
      this.ReciptData.AmountDiscount = 0;
    }
    if (this.ReciptData.AmountST == null) {
      this.ReciptData.AmountST = 0;
    }
    if (this.ReciptData.AmountTDS == null) {
      this.ReciptData.AmountTDS = 0;
    }
    if (this.ReciptData.PrintCount == null) {
      this.ReciptData.PrintCount = 0;
    }
    this.ReciptData.FK_AdjustedBillId = parseInt(this.ReciptData.FK_AdjustedBillId);

    // this.checkamount=this.checkamount + this.ReciptData.CurrencyAmount;

    var receiptData = this.adjuctbillAmount.filter(item => item.fK_PartyId == this.ReciptData.FK_PartyId);
    if (receiptData.length > 0) {
      var caclucateamount = 0;
      receiptData.forEach(data => {
        caclucateamount = caclucateamount + data.adjustedAmount;
      });
      this.checkamount = caclucateamount;

    } else {
      this.checkamount = 0;
    }


    if (this.patientPartyTpaconf == 'N') {
      // if(this.newdata.length!=0)
      // {
      var checkaount = 0;
      if (this.newdata.length > 0) {
        checkaount = this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount;
      } else {
        checkaount = 0;
      }
      if (this.data.balanceAmount > 0 && ((checkaount - this.checkamount) >= this.ReciptData.CurrencyAmount) && this.ReciptData.CurrencyAmount > 0) {

        if (this.data.balanceAmount >= this.ReciptData.CurrencyAmount) {
          //configuration setting
          this.cuurentTime = new Date().toTimeString().split(" ")[0];
          this.RefundData.FK_BranchId = this.authService.Loggeduser.branchid;
          if (this.opdvisitService.PatientisExpire === true) {
            this.dashboardService.openSnackBar("You Can't create a receipt of Expired Patient ", "OK");
            this.showspinner = false;
            return;
          }
          else {
            this.ReciptData.FK_DepositHeadId = parseInt(this.ReciptData.FK_DepositHeadId)
            this.ReciptData.FK_PayTypeId = parseInt(this.ReciptData.FK_PayTypeId);
            if (this.ReciptData.FK_AdjustedBillId > 0) {
              this.ReciptData.IsAdjusted = this.ReciptData.IsAdjusted;

            }
            else {
              this.ReciptData.IsAdjusted = 0;
            }

            this.ReciptData.FK_DepositTypeId = this.ReciptData.FK_DepositTypeId;
            this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);
            this.ReciptData.AmountINR = parseInt(this.ReciptData.AmountINR);

            this.ReciptData.PaymentTime = new Date().toTimeString().split(" ")[0]
            this.ReciptData.AmountINR = this.ReciptData.CurrencyAmount;
            if (this.ReciptData.FK_AdjustedBillId === null || this.ReciptData.FK_AdjustedBillId === ' ' ||
              this.ReciptData.FK_AdjustedBillId === undefined) {
              this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
              this.showspinner = false;
              return;
            }

            //  if(this.BillReciptAmount  < this.ReciptData.CurrencyAmount){
            //   this.dashboardService.openSnackBar("Reciept Amount can't be greater then bill Amount", "OK");
            // }
            // else{
            this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);


            if (this.ReciptData.FK_PayTypeId != 1) {
              if (this.ReciptData.ChequeNo && (this.ReciptData.FK_ChqBankId || this.show == false)) {
                console.log(this.ReciptData.FK_ChqBankId);
                this.ReciptData.FK_ChqBankId = parseInt(this.ReciptData.FK_ChqBankId);
                this.ReciptData.ChequeNo = this.ReciptData.ChequeNo;
                this.ReciptData.ChequeDate = this.ReciptData.ChequeDate;
                this.dyanmiccheck = false;
                this.ReciptData.PaymentDate =this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd")

                this.showspinner = true;
                this.ReciptData.AgeYear=this.opdvisitService.patientdetails.ageYear;
                this.ReciptData.AgeMonth=this.opdvisitService.patientdetails.ageMonth;
                this.ReciptData.AgeDays=this.opdvisitService.patientdetails.ageDays;
                this.ReciptData.IsEdit=this.ReciptData.PK_ReceiptId >0?true:false;
                this.ReciptData.ReqType='B';
                this.billingservice.addrecipts(this.ReciptData).
                  subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

              }
              else {
                this.dashboardService.openSnackBar("Please check all mandatory fields", "ok");
                this.showspinner = false;
                return
              }

            }
            else {

              this.dyanmiccheck = false;
              this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd")
              this.ReciptData.AgeYear=this.opdvisitService.patientdetails.ageYear;
              this.ReciptData.AgeMonth=this.opdvisitService.patientdetails.ageMonth;
              this.ReciptData.AgeDays=this.opdvisitService.patientdetails.ageDays;
              this.ReciptData.IsEdit=this.ReciptData.PK_ReceiptId >0?true:false;
              this.ReciptData.ReqType='B';
              this.billingservice.addrecipts(this.ReciptData).
                subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

            }
           


          }
        }

        else {
          this.dashboardService.openSnackBar("selected party name can't pay more than " + this.ReciptData.AmountINR, "ok");
          this.showspinner = false;
          return;
        }
      }
      else {
        var diffvalue = 0;
        if (this.newdata.length > 0) {

          diffvalue = (this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount) - this.checkamount;
        } else {
          diffvalue = 0
        }

        this.dashboardService.openSnackBar("You can't create receipt your Net Amount is " + diffvalue, "ok");
        this.showspinner = false;
        return;
      }
    }
    else {
      if (this.newdata.length != 0) {
        if (this.data.Billdetail.length == 1) {
          var totalamount = this.data.Billdetail[0];
        } else {
          var totalamount = this.data.Billdetail[0].amount + this.data.Billdetail[1].amount;
        }
        if ((this.data.balanceAmount > 0 && this.ReciptData.CurrencyAmount > 0)) {
          var checkyamount = 0;
          var checkpartyid = 0;
          if (this.newdata.length > 0) {
            checkyamount = this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount;
            checkpartyid = this.newdata[0].fK_PartyId ? this.newdata[0].fK_PartyId : this.newdata[0].FK_PartyId;
          } else {
            checkyamount = 0;
            checkpartyid = 0;
          }
          if (((checkyamount) >= this.ReciptData.CurrencyAmount) && (((checkyamount) - this.checkamount) >= this.ReciptData.CurrencyAmount) && ((checkpartyid) === this.ReciptData.FK_PartyId)) {
            this.cuurentTime = new Date().toTimeString().split(" ")[0];
            this.RefundData.FK_BranchId = this.authService.Loggeduser.branchid;
            if (this.opdvisitService.PatientisExpire === true) {
              this.dashboardService.openSnackBar("You Can't create a receipt of Expired Patient ", "OK");
              this.showspinner = false;
              return;
            }
            else {
              this.ReciptData.FK_DepositHeadId = parseInt(this.ReciptData.FK_DepositHeadId)
              this.ReciptData.FK_PayTypeId = parseInt(this.ReciptData.FK_PayTypeId);
              if (this.ReciptData.FK_AdjustedBillId > 0) {
                this.ReciptData.IsAdjusted = this.ReciptData.IsAdjusted;

              }
              else {
                this.ReciptData.IsAdjusted = 0;
              }

              this.ReciptData.FK_DepositTypeId = this.ReciptData.FK_DepositTypeId;
              this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);
              this.ReciptData.AmountINR = parseInt(this.ReciptData.AmountINR);

              this.ReciptData.PaymentTime = new Date().toTimeString().split(" ")[0]
              this.ReciptData.AmountINR = this.ReciptData.CurrencyAmount;
              if (this.ReciptData.FK_AdjustedBillId === null || this.ReciptData.FK_AdjustedBillId === ' ' ||
                this.ReciptData.FK_AdjustedBillId === undefined) {
                this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
                this.showspinner = false;
                return;
              }

              this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);


              if (this.ReciptData.FK_PayTypeId != 1) {
                if (this.ReciptData.ChequeNo && (this.ReciptData.FK_ChqBankId || this.show == false)) {
                  console.log(this.ReciptData.FK_ChqBankId);
                  this.ReciptData.FK_ChqBankId = parseInt(this.ReciptData.FK_ChqBankId);
                  this.ReciptData.ChequeNo = this.ReciptData.ChequeNo;
                  this.ReciptData.ChequeDate = this.ReciptData.ChequeDate;
                  this.dyanmiccheck = false;
                  this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
                  this.ReciptData.AgeYear=this.opdvisitService.patientdetails.ageYear;
                  this.ReciptData.AgeMonth=this.opdvisitService.patientdetails.ageMonth;
                  this.ReciptData.AgeDays=this.opdvisitService.patientdetails.ageDays;
                   this.ReciptData.IsEdit=this.ReciptData.PK_ReceiptId >0?true:false;
                   this.ReciptData.ReqType='B';
                  this.billingservice.addbilingrecipts(this.ReciptData).
                    subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

                }
                else {
                  this.ChequeNoValidation = true
                 this.ChqBankIdValidation = true;
                  this.dashboardService.openSnackBar("Please check all mandatory fields ", "ok");
                  this.showspinner = false;
                  return;
                }

              }
              else {
                this.dyanmiccheck = false;
                this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
                this.ReciptData.AgeYear=this.opdvisitService.patientdetails.ageYear;
                this.ReciptData.AgeMonth=this.opdvisitService.patientdetails.ageMonth;
                this.ReciptData.AgeDays=this.opdvisitService.patientdetails.ageDays;
                 this.ReciptData.IsEdit=this.ReciptData.PK_ReceiptId >0?true:false;
                 this.ReciptData.ReqType='B';
                this.billingservice.addbilingrecipts(this.ReciptData).
                  subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

              }



            }
          }
          else {
            var checkvalidamount = 0;
            if (this.newdata.length > 0) {
              checkvalidamount = this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount;
            } else {
              checkvalidamount = 0;
            }
            this.dashboardService.openSnackBar("selected party name can't pay more than " + (checkvalidamount), "ok");
            this.showspinner = false;
            return;
          }
        } else {
          var diffvalue = 0;
          if (this.newdata.length > 0) {

            diffvalue = (this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount) - this.checkamount;
          } else {
            diffvalue = 0
          }
          this.AmountValidation = true;
          this.dashboardService.openSnackBar("You Can't Create Receipt Your Net Amount is " + diffvalue, "ok");
          this.showspinner = false;
          return;
        }
      }
      else {
        this.PartyValidation = true
        this.dashboardService.openSnackBar("please select proper party Name ", "ok");
        this.showspinner = false;
        return;
      }
    }

  }





  
  recipt_Succsess(data) {
    this.AmountValidation = false;
    this.PartyValidation = false;
    this.ChequeNoValidation = false;
    this.PartyValidation = false;
    this.ChqBankIdValidation=false;
    this.showspinner = false;
    if (this.ReciptData.PK_ReceiptId > 0) {
      this.dashboardService.openSnackBar("Receipt Updated Successfully", "OK");
    }
    else {
      this.dashboardService.openSnackBar("Receipt Created Successfully", "OK");
    }

    this.get_recipt(this.PatientId, this.BillID, 0);
    this.setrefundformdata();
    this.ReciptData.CurrencyAmount = 0;
    //  this.ReciptData.CurrencyAmount =0;

  }
  recipt_failed(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   
  }


  openRefunddailog(id: number, a: number, nun: any, refundtype: any, netamount: any, billrefund: any, paydate: any) {
    if (this.checkreceiptselect == true) {
      const dialogRef = this.dialog.open(RefundComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '100vw !important',
        height: '100%',
        width: '100%',
        data: { recieptId: id, Amount: a, no: nun, ReciptDataobj: this.ReciptData, refundType: refundtype, netAmount: netamount, billRefund: billrefund, PaymentDate: paydate, billId: this.BillID }
      });

      dialogRef.afterClosed().subscribe(result => {

        this.get_recipt(this.PatientId, this.BillID, 0);

      })
    } else {
      this.dashboardService.openSnackBar("Please select Receipt First ", "OK");
    }

  }


  // refund Section 
  setrefundformdata() {
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.RefundData.FK_BranchId = this.authService.Loggeduser.branchid;
    this.RefundData.RefundType = 'B';
    this.RefundData.RefundDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.RefundData.RefundTime = this.cuurentTime;
    this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
    this.RefundData.RefundReason = null;
    this.RefundData.FK_PayTypeId = this.ReciptData.FK_PayTypeId;
    this.RefundData.FK_CurrencyId = 1;
    this.RefundData.CurrencyAmount = this.ReciptData.CurrencyAmount;
    this.RefundData.ConvertRetio = 1;
    this.RefundData.RefundAmount = this.ReciptData.CurrencyAmount;
    this.RefundData.ChequeNo = null;
    this.RefundData.ChequeDate = null;
    this.RefundData.FK_ChqBankId = null;
    this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.RefundData.IsActive = 1;
    this.RefundData.PK_RefundId = 0;



  }




  getAdjustedvalue(data, patyid: any) {


    var adjustData = {

      "FK_ReceiptId": data.pK_ReceiptId,

      "FK_AdjustedBillid": this.BillID,

      "AdjustedAmount": parseInt(data.netAmt),

      "FK_AdjustedById": this.ReciptData.FK_CreatedById,
      "IsAdjusted":1

    }

    // console.log(adjustData);

    this.AdjustedBillArray = null;
    if (this.patientPartyTpaconf == 'Y') {
      if (patyid == this.newdata[0].fK_PartyId) {
        if (this.BillReciptAmount >= adjustData.AdjustedAmount && this.BillReciptAmount > 0) {

          this.billingservice.addPartialAmount(adjustData).subscribe(data =>

            this.success_partialAmount(data), err => this.failed_partialAmount(err))

        }

        else {
          this.get_recipt(this.PatientId, this.BillID, 0);
          this.dashboardService.openSnackBar("Net Received Amount is more than Net Bill Amount , Please refund First Access Amount ,OR you can do Partial AdjustReciept Amount is not equal to Bill Amount", "OK");

        }
      } else {
        this.get_recipt(this.PatientId, this.BillID, 0);
        this.dashboardService.openSnackBar("Full Adjustment is not Allowed", "OK");
      }

    } else {
      if (this.BillReciptAmount >= adjustData.AdjustedAmount && this.BillReciptAmount > 0) {

        this.billingservice.addPartialAmount(adjustData).subscribe(data =>

          this.success_partialAmount(data), err => this.failed_partialAmount(err))

      }

      else {
        this.get_recipt(this.PatientId, this.BillID, 0);
        this.dashboardService.openSnackBar("Net Received Amount is more than Net Bill Amount , Please refund First Access Amount ,OR you can do Partial AdjustReceipt Amount is not equal to Bill Amount", "OK");

      }
    }



    var adjustArray: any = [];

    data.isAdjusted = true;
    data.fK_AdjustedBillId = adjustData.FK_AdjustedBillid;

    adjustArray.push(data);

    // this.adjustreciepts(adjustArray)

  }
  getadjustedbills(id: number, reciept?: any, i?: any) {

    this.deposittype = reciept.depositType;
    this.AdjustedBillArray = [];
    this.setreciptdata(reciept);
    this.totalpadamountAgainstBill = 0;
    var Amount: number = 0;
    // if (reciept.isAdjusted == true || reciept.IsAdjusted == true || this.checkpartial==true) {
    this.checkpartial = false;
    this.billingservice.getAdustedDetails(id, 0).subscribe(data => {
      if (data.statusCode) {

      }
      else {
        this.AdjustedBillArray = data;
        this.isprint = true;
      }
    });
    // }


  }

  submitAdjustedamount() {

    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.ReciptData.FK_DoctorId = this.billingservice.billserviceConfig.fK_DoctorId;
    this.ReciptData.FK_BillingCompanyId = this.authService.Loggeduser.billingcompanyid;
    this.ReciptData.FK_FinyearId = this.authService.Loggeduser.finyear;
    this.ReciptData.FK_BranchId = this.authService.Loggeduser.branchid;
    this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.ReciptData.PaymentTime = this.cuurentTime;

    var adjustData = {
      "PK_TranId": 0,
      "FK_ReceiptId": this.ReciptData.PK_ReceiptId,
      "FK_AdjustedBillid": this.ReciptData.FK_AdjustedBillId,
      "AdjustedAmount": parseInt(this.PartialAmount),
      "FK_AdjustedById": this.ReciptData.FK_CreatedById,
      "IsAdjusted": null
    }

    this.AdjustedBillArray = null;
    if (this.ReciptData.PK_ReceiptId > 0) {
      if (this.patientPartyTpaconf == 'Y') {
        if (this.ReciptData.FK_PartyId == this.newdata[0].fK_PartyId) {
          this.showspinner = true;
          this.billingservice.addPartialAmount(adjustData).subscribe(data =>
            this.success_partialAmount(data), err => this.failed_partialAmount(err)
          )
        } else {
          this.dashboardService.openSnackBar("Please select Party Name Correct ", "OK")
        }
      } else {
        this.showspinner = true;
        this.billingservice.addPartialAmount(adjustData).subscribe(data =>
          this.success_partialAmount(data), err => this.failed_partialAmount(err)
        )
      }
    } else {
      this.dashboardService.openSnackBar("Please select Receipt List First", "OK")
    }



  }

  refreshdata() {
    this.ngOnInit();
  }
  checkpartial: boolean = false;
  success_partialAmount(data) {

    this.showspinner = false;
    this.checknetAmount=0;
    //  this.ngOnInit();
    this.get_recipt(this.PatientId, this.BillID, 0);
    this.checkpartial = true;
    this.getadjustedbills(this.ReciptData.PK_ReceiptId, this.ReciptData);
    this.rowClicked = -1;
    this.dashboardService.openSnackBar("Receipt  Successfully  Adjusted With Current Bill ", "OK");

  }

  failed_partialAmount(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  unadjustreciepts(data: any) {
    if(data.iscancelled !=true){
      this.Unadjustobj = {};
      this.Unadjustobj = data;
      document.getElementById("UnadjustReciept").style.display = "block";
    }else{
      this.dashboardService.openSnackBar("Receipt Already Cancelled  You Can't Adjusted", "OK");
    }
    
  }

  unadjustRec() {
    this.showspinner = true;
    var data: any = [];
    data.push(this.Unadjustobj);
    this.billingservice.adjustbill(data).subscribe(data => this.adjust_reciept_sucsess(data), err => this.adjust_reciept_error(err))

  }

  closeunadjustRec() {
    this.get_recipt(this.PatientId, this.BillID, 0);
    document.getElementById("UnadjustReciept").style.display = "none";
    // this.setreciptdata(data);
  }

  adjust_reciept_sucsess(data) {

    this.showspinner = false;
    this.dashboardService.openSnackBar("Receipt  Successfully  Adjusted With Current Bill ", "OK");
    // this.billingservice.getAdustedDetails(this.Unadjustobj.pK_ReceiptId,this.BillID).subscribe(item=>{
    //   this.AdjustedBillArray =item[0];
    //   this.updateadjustedAmount(0,this.AdjustedBillArray);
    // })
    this.get_recipt(this.PatientId, this.BillID, 0);
    this.dashboardService.openSnackBar("Receipt UnAdjusted  Successfully  ", "OK");
    this.Unadjustobj = {}
    document.getElementById("UnadjustReciept").style.display = "none";
    // console.log('adjust sucsess',data);
  }

  adjust_reciept_error(err) {
    //  console.log('adjust err',err);
    this.Unadjustobj = {}
    document.getElementById("UnadjustReciept").style.display = "none";
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }



  closePartialAmount() {
    document.getElementById("PartialAmountModel").style.display = "none";
  }

  openPartialAMount() {
    this.checkpartialAdjust = true;
    if (this.ReciptData.PK_ReceiptId > 0) {
      if (this.checkpartialAdjust == true) {
        document.getElementById("PartialAmountModel").style.display = "block";
      }
    } else {
      this.dashboardService.openSnackBar("Please select Receipt List First", "OK")
    }
  }

  getPartialAmount(amount: number) {

    if ((this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount) >= amount) {
      this.PartialAmount = amount;
      console.log(this.PartialAmount);
      this.PartialBalancedAmmount = parseInt(this.ReciptData.CurrencyAmount) - parseInt(this.PartialAmount);
      console.log(this.PartialBalancedAmmount);
    }
    else {
      this.PartialAmount = amount;
      this.dashboardService.openSnackBar("Select PartyName Can't Pay More Than  " + (this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount), "OK");
    }


  }
  checkamountpartial: any = 0
  setpartialRecipt() {
   
    if (this.checknetAmount > 0) {
      var receiptData = this.adjuctbillAmount.filter(item => item.fK_PartyId == this.ReciptData.FK_PartyId);
      if (receiptData.length > 0) {
        var caclucateamount = 0;
        receiptData.forEach(data => {
          caclucateamount = caclucateamount + data.adjustedAmount;
        });
        this.checkamountpartial = caclucateamount;

      } else {
        this.checkamountpartial = 0;
      }
      var advancedrecept = this.ReciptArray.filter(item => item.fK_PartyId == this.ReciptData.FK_PartyId && (item.pK_ReceiptId == this.selectreceiptid));
      if (advancedrecept.length > 0) {
        if(parseInt(this.PartialAmount) > this.checknetAmount){
          this.dashboardService.openSnackBar("Select PartyName Can't Pay More Than  " + this.checknetAmount, "OK");
        }else
        if (parseInt(this.PartialAmount) > (advancedrecept[0].amount - advancedrecept[0].refunded) || parseInt(this.PartialAmount) <= 0 || parseInt(this.PartialAmount) > this.checknetAmount) {
          this.dashboardService.openSnackBar("Amount should not be less than or equals to Zero (0)", "OK");
        } else {
          if (((this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount) - this.checkamountpartial) >= parseInt(this.PartialAmount)) {
            this.AdjustedBillArray = null;
            this.billingservice.AdjustedBillingAmount = 0;
            this.ReciptData.AmountINR = this.PartialBalancedAmmount;
            this.ReciptData.FK_AdjustedBillId = this.BillID;
            // console.log('adjRec',this.ReciptData);

            this.submitAdjustedamount();
            document.getElementById("PartialAmountModel").style.display = "none";
          } else {
            this.dashboardService.openSnackBar("Select PartyName Can't Pay More Than  " + (this.newdata[0].amount ? this.newdata[0].amount : this.newdata[0].Amount), "OK");
          }
        }
      }

    }else{
      this.dashboardService.openSnackBar("You Can't Adjust more than NetAmount(0). ", "OK");
    }


  }


  prientReciprt(rid) {
    if (rid) {
      window.open(this.reporturl + 'Receipt.aspx?ReceiptId=' + rid + '&BranchId=' + this.authService.Loggeduser.branchid + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&PageHeadWebReport=' + 'Y');
    }
    else {
      this.dashboardService.openSnackBar("Please Select Receipt ", "OK");
    }


  }


  failedurl(err) {
    this.dashboardService.openSnackBar("summary api url failed ", "OK");
  }


  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    })
  }
  patientData: any;
  getdata(param) {
    if (param != null) {
      this.opdvisitService.getpatientdetailsforReciept(param).subscribe((data: any) => {

        this.patientData = data;

      })

    }

  }
  printTimeline(id){
   
      let checkreporttype = this.authService.webreportConfig.filter(item=>item.printOption=='Receipt' && item.printType =='NetramReport');
      if(checkreporttype.length >0){
      this.prientReciprt(id);
      }else{
      this. printTimelinedata(id);
      }
    
  }
  Doctornamedata(id){
    return this.opdvisitService.doctors.filter(item=>item.userId ==id)[0]?.userName;
   }
  printTimelinedata(rid) {
    
    if (rid) {
      const recpdata = this.ReciptArray.filter(item => item.pK_ReceiptId == rid);
    //  let receviedAmount = this.data.totalAmount - this.data.discount;
      if (recpdata[0]?.fK_RegId != null) {
        this.opdvisitService.getpatientdetailsforReciept(recpdata[0]?.fK_RegId).subscribe((data: any) => {
          this.patientData = data;
          let payload = {
            "WebReportPrintMaster": {
              "module": "Receipt",
              "printOption": "Receipt",
              "printType": "WebNetramReport",
              "PATIENTNAME": this.patientData.firstName +
                " " +
                this.patientData.lastName,
              "MRDNO": this.patientData.pkRegId,
              "Pk_RegId":this.patientData.pkRegId,
              "MobileNo": this.patientData.mobileNo,
              "PatientAddress": this.patientData.paddress,
              "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
              // "VisitDate": this.datePipe.transform(this.emrservice.visitDate, "dd-MM-yyyy"),
              "PrintTime": this.convertTime12Hour(new Date()),
              "PatientAge":recpdata[0]?.age?recpdata[0]?.age:this.patientData.ageYear,
              "PatientGender": this.patientData.sex,
              "PatientAgeAndGender": recpdata[0]?.age?recpdata[0]?.age:this.patientData.ageYear + '|' + this.patientData.sex,
              "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
              "LINE1": this.branchmansterObj.line1,
              "LINE2": this.branchmansterObj.line2,
              "LINE3": this.branchmansterObj.line3,
              "LINE4": this.branchmansterObj.line4,
              "HOSPITALIMAGE": `${window.location.origin}/${this.authService.loginclientlogo}`,
              "COMPANYIMAGE": `${window.location.origin}/${this.authService.leftbottomlogosm}`,
              "CERTIFICATE1IMAGE": `${window.location.origin}/${this.authService.nabhlogo}`,
              "CERTIFICATE2COMPANYIMAGE": '',
              "AdvisedBy": recpdata[0]?.createdBy ? recpdata[0]?.createdBy:this.authService.Loggeduser.firstname,
              "DOCTORNAME": this.Doctornamedata(recpdata[0]?.fK_DoctorId),
              "RECEIPTNO": this.ReciptData.receiptNoFull,
              "RECEIPTDATE": this.datePipe.transform(recpdata[0]?.payDate, "dd-MM-yyyy"),
              "DEPOSITETYPE": recpdata[0]?.depositType,
              "MOP": recpdata[0]?.payType,
              "MOPID": recpdata[0]?.chequeNo,
              "PARTYNAME": recpdata[0]?.partyName,
              "HEADNAME": this.headData(recpdata[0]?.fK_DepositHeadId),
              "AMOUNT": recpdata[0]?.amount,
              "AMOUNTINWORDS": this.converIntoWord(recpdata[0]?.amount),
              "AMOUNTDISCOUNT": recpdata[0]?.recpdata,
              "RECEIPTTIME":this.ReciptData.UserRemarks?this.ReciptData.UserRemarks:'',
              "Pk_BranchId": this.authService.Loggeduser.branchid,
              "Pk_LoggedUserId":this.authService.Loggeduser.userid,
              "ReceiptArray":'Y',
              "PatientRegistrationArray":'Y',
              "PrintHeaderArray":'Y',
            }

          }

          this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
            if (x.length > 0) {
              let printContents, popupWin;

              printContents = x[0].printTemplate;
              popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

              popupWin.document.open();
              popupWin.document.write(`
    <html>
     
  <body onload="window.print()">${printContents}
  </body>
    </html>`
              );

              popupWin.document.close();
              if(this.patientData.emailAddress !=null && this.patientData.emailAddress !=undefined && this.patientData.emailAddress !=""){
                const formData = new FormData();
                formData.append('EmailCC', '');
                formData.append('SubjectCustom',"Receipt");
                formData.append('EmailType', 'CORPORATE DETAIL');
                formData.append('ToEmail', this.patientData.emailAddress);
                formData.append('MessageTemplateCustom', printContents);
                this.billingservice.sendEmail(formData).subscribe(data => {
                 
                  this.dashboardService.openSnackBar(data.message, 'Ok');
                 
                });
              } 
            } else {
              this.dashboardService.openSnackBar("Report Template Not Set", "OK");
            }
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          })
        })

      }
    } else {
      this.dashboardService.openSnackBar("Please Select Receipt ", "OK");
    }
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour > 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }
  converIntoWord(balanceamount: number) {
    const numWords = require('num-words');
    const amountInWords = numWords(balanceamount);
    return amountInWords.toUpperCase();
  }
  headData(param) {
    if (param != null) {
      const headnamedata = this.billingservice.billService.filter(item => item.billSerieseId == param);
      if (headnamedata.length > 0) {
        return headnamedata[0].billSerieseName;

      } else {
        return null;
      }
    } else {
      return null;
    }


  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
}




